import type { AppCopy } from '../catalogs';

export const itAppCopy = {
  welcomeHeading: 'Come posso aiutarti oggi?',
  thinking: 'Pensare',
  scrollToBottom: 'Scorri fino in fondo',
  reasoning: 'Ragionamento',
  reasoningInProgress: 'in corso',
  citationPages: 'Pagine {first}–{last}',
  citationTitle: 'Estratto della fonte',
  citationLoading: 'Caricamento della fonte…',
  citationUnavailable: 'Il testo citato non è disponibile o non hai più accesso.',
  citationOpen: 'Apri fonte',
  citationCopied: 'Citazione copiata',
  copy: 'Copia',
  more: 'Di più',
  tryAgain: 'Riprova',
  answerTruncated: 'La risposta ha raggiunto il limite di lunghezza ed è stata troncata.',
  continueAnswer: 'Continua la risposta',
  exportMarkdown: 'Esporta come Markdown',
  edit: 'Modifica',
  cancel: 'Annulla',
  update: 'Aggiorna',
  previous: 'Precedente',
  next: 'Avanti',
  messagePlaceholder: 'Invia un messaggio...',
  projectHomePlaceholder: 'Nuova chiacchierata in {project}',
  sharedChatEveryone: 'Tutti in {company} possono leggere questa chat',
  sharedChatOnePerson: '1 persona può leggere questa chat',
  sharedChatPeople: '{count} persone possono leggere questa chat',
  forkedChatPlaceholder: 'Continua con le tue connessioni…',
  newAnswer: 'Nuova risposta',
  messageInput: 'Inserimento del messaggio',
  sendMessage: 'Invia messaggio',
  stopGenerating: 'Smetti di generare',
  addAttachment: 'Aggiungi allegato',
  removeFile: 'Rimuovi file',
  attachmentPreview: "Anteprima dell'allegato",
  imageAttachmentPreview: "Anteprima dell'allegato immagine",
  image: 'Immagine',
  openLink: 'collegamento aperto',
  document: 'Documento',
  file: 'Archivio',
  attachment: 'attaccamento',
  uploadFailed: 'caricamento non riuscito',
  uploading: 'caricamento',
  toolIncomplete: 'Incompleto',
  toolActivity: 'Attività',
  activityThinking: 'Ragionamento…',
  activityWriting: 'Scrittura…',
  activityWaiting: 'In attesa della tua approvazione',
  activityStopped: 'Interrotto',
  activityCouldNotFinish: 'Impossibile completare',
  activitySources: 'fonti',
  activityShowThinking: 'Mostra ragionamento',
  activityOpen: 'Apri attività',
  activitySteps: 'Passaggi',
  activitySourcesTab: 'Fonti',
  activityUnavailable: 'Questa attività non è disponibile.',
  activityInput: 'Input',
  activityOutput: 'Output',
  activityNoSources: 'La risposta non cita fonti.',
  activityApprovedByReply: 'Approvato dalla tua risposta',

  toolRunning: 'In corso',
  toolComplete: 'Completato',
  toolNeedsApproval: 'Approvazione richiesta',
  toolInput: 'Input',
  toolCall: 'chiamata dello strumento',
  toolCalls: 'chiamate dello strumento',
  openMenu: 'Apri il menu',
  closeMenu: 'Chiudi menù',
  close: 'Chiudi',
  showInTextField: 'Mostra nel campo di testo',
  settings: 'Impostazioni',
  appearance: 'Aspetto',
  themeLight: 'Chiaro',
  themeDark: 'Scuro',
  themeSystem: 'Sistema',
  themeChoiceHelp:
    'Si applica su tutti i tuoi dispositivi. «Sistema» segue la modalità chiara o scura di ciascun dispositivo.',
  themeSaveFailed: 'Non è stato possibile salvare l’aspetto, quindi è rimasto invariato. Riprova.',
  toolUsed: 'Strumento utilizzato',
  toolCancelled: 'Strumento annullato',
  toolResult: 'Risultato:',
  toolError: 'Errore:',
  toolCancelledReason: "Motivo dell'annullamento:",
  approvalAllow: 'Consenti',
  approvalAlwaysAllow: 'Consenti sempre',
  approvalDeny: 'Nega',
  approvalAlwaysDeny: 'Nega sempre',
  approvalConfirm: 'Conferma',
  approvalBack: 'Indietro',
  approvalApprovedResult: "Approvato dall'utente",
  approvalDeniedResult: "L'utente ha negato l'esecuzione dello strumento",
  logout: 'Esci',
  loginOrCreateAccount: 'Accedi / Crea un account',
  newChat: 'Nuova chiacchierata',
  untitledChat: 'Chat senza titolo',
  previousChats: 'Chat precedenti',
  openChat: 'Apri la chat {title}',
  moreActionsForChat: 'Più azioni per {title}',
  chatActions: 'Azioni di chat',
  closeChatActions: 'Chiudi le azioni della chat',
  deleteChatQuestion: 'Eliminare la chat?',
  deleteChatDescription: 'La chat “{title}” verrà eliminata definitivamente.',
  deleteChat: 'Elimina la chat',
  keepChat: 'Mantieni la chat',
  delete: 'Elimina',
  deleting: 'Eliminazione…',
  chatDeleteFailed: 'Impossibile eliminare la chat. Riprova.',
  settingsDescription: "Personalizza il modo in cui l'assistente lavora per te.",
  settingsDesktopDescription: "Personalizza il modo in cui l'assistente ti risponde.",
  personalization: 'Personalizzazione',
  personalizationDescription: "Personalizza le istruzioni che l'assistente segue in ogni risposta.",
  languageAndRegion: 'Lingua e regione',
  languageAndRegionDescription: 'Scegli la lingua e il fuso orario.',
  memories: 'Ricordi',
  memoriesDescription: "Visualizza, modifica o elimina ciò che l'assistente ricorda di te.",
  account: 'Conto',
  accountDescription: "Gestisci l'account e cancella definitivamente i tuoi dati.",
  backToSettings: 'Torna alle impostazioni',
  closeSettings: 'Chiudi le impostazioni',
  settingsCategories: 'Categorie di impostazioni',
  yourSettings: 'Le tue impostazioni',
  dataAndAccount: 'Dati e conto',
  viewAndManageMemories: "Visualizza e gestisci ciò che ricorda l'assistente",
  loginToUseMemories: 'Accedi per utilizzare i ricordi',
  manageOrDeleteAccount: "Gestisci o elimina l'account",
  unsavedChanges: 'Sono presenti modifiche non salvate',
  unsavedCloseDescription:
    'La chiusura delle impostazioni eliminerà le modifiche in questa pagina.',
  unsavedBackDescription:
    'Se torni indietro, le modifiche apportate a questa pagina verranno annullate.',
  continueEditing: 'Continua a modificare',
  discardChanges: 'Annulla modifiche',
  saveChanges: 'Salva modifiche',
  localSettingsNote: 'Salvato in questo browser. Accedi per salvare sul tuo account.',
  personality: 'Personalità',
  personalityHelp: "Istruzioni personalizzate che l'assistente segue in ogni risposta",
  personalityPlaceholder:
    'Ad esempio: sii conciso e concreto. Vivo a Göteborg e mi piace il cibo vegetariano.',
  timezone: 'Fuso orario',
  searchTimezone: 'Cerca fusi orari…',
  automaticBrowser: 'Automatico (browser)',
  saved: 'Salvato {date}',
  addMemory: 'Aggiungi ricordo',
  newMemory: 'Nuovo ricordo',
  memoryPlaceholder: 'Ad esempio: Preferisco risposte brevi e concrete.',
  editMemory: 'Modifica ricordo',
  saveMemory: 'Salva ricordo',
  deleteMemory: 'Elimina ricordo',
  memorySaveFailed: 'Non è stato possibile salvare la memoria. Riprova.',
  memoryLimitReached:
    'Puoi salvare fino a 50 ricordi. Eliminane uno prima di aggiungerne un altro.',
  memoryInvalid: 'I ricordi non possono contenere link. Rimuovi il link e riprova.',
  memoryDeleteFailed: 'Non è stato possibile cancellare la memoria. Riprova.',
  memoryLoadFailed: 'Impossibile caricare le memorie.',
  loadingMemories: 'Caricamento ricordi...',
  emptyMemories:
    "L'assistente salva ricordi su di te mentre parli: cosa ti piace, dove vivi e cosa fai. Puoi visualizzarli, modificarli ed eliminarli qui.",
  deleteAccountHelp:
    "Elimina definitivamente l'account e tutte le chat, i ricordi e le impostazioni correlati.",
  deleteAccount: 'Elimina account',
  deleteAccountQuestion: "Eliminare definitivamente l'account?",
  deleteAccountDescription:
    'Tutte le chat, i messaggi, i ricordi, le impostazioni e le credenziali di accesso verranno eliminati. Questa azione non può essere annullata.',
  deleteAccountConfirm: 'Sì, cancella il mio account',
  accountDeleteFailed: "Impossibile eliminare l'account. Non è stato rimosso nulla: riprova.",
  logoutEverywhereTitle: 'Tutti i dispositivi',
  logoutEverywhereHelp:
    'Esci da tutti i dispositivi e browser in cui il tuo account è aperto, compreso questo.',
  logoutEverywhere: 'Esci ovunque',
  logoutEverywhereQuestion: 'Uscire da tutti i dispositivi?',
  logoutEverywhereDescription:
    'Dovrai accedere di nuovo su tutti i dispositivi e browser, compreso questo. Le tue chat e impostazioni restano come sono.',
  loggingOut: 'Uscita in corso…',
  logoutEverywhereFailed:
    "Non è stato possibile confermare l'uscita ovunque. Riprova, oppure controlla su un altro dispositivo se hai ancora effettuato l'accesso.",
  settingsSaveFailed: 'Impossibile salvare le impostazioni. Riprova.',
  customInstructions: 'Istruzioni personalizzate',
  notSet: 'Non impostato',
  automaticLanguage: 'Lingua automatica',
  automaticTimezone: 'fuso orario automatico',
  appLanguage: "Lingua dell'app",
  appLanguageHelp:
    "Controlla l'intera interfaccia dell'app e le date. Le risposte dell'assistente continuano a seguire la lingua in cui scrivi.",
  automaticBrowserLanguage: 'Automatico (lingua del browser)',
  previousLanguageChoice: 'Scelta precedente: {language} ({locale})',
  previousLanguageChoiceCode: 'Scelta precedente ({locale})',
  canvasCopyLink: 'Copia link',
  canvasLinkCopied: 'Link copiato',
  actionUpdatedWithEdits: 'Aggiornato con le modifiche',
  activityStepsDone: 'one:passaggio completato|other:passaggi completati',
  activityResultsCount: 'one:risultato|other:risultati',
  canvasCopyLinkFailed: 'Impossibile copiare il link',
  canvasOpenInAgent: 'Apri in {agent}',
  canvasExpand: 'Espandi',
  canvasExitFullView: 'Esci dalla vista completa',
  webSourceUnread:
    "Collegato in questa risposta. Poneva non ha letto questa pagina, quindi qui non c'è nulla da mostrare.",
  webSourceOpenOriginal: 'Apri originale',
  toolProgressSettings: 'Modifica delle tue impostazioni…',
  toolProgressAgent: 'Creazione dell’agente…',
  toolProgressConnections: 'Ricerca delle opzioni di collegamento…',
  toolProgressResult: 'Preparazione del risultato…',
  toolProgressClarification: 'Preparazione di un chiarimento…',
  toolProgressKnowledge: 'Preparazione di un aggiornamento suggerito delle conoscenze…',
  toolProgressQuestion: 'Preparazione di una domanda per te…',
  toolProgressSkill: 'Definizione della tua Skill…',
  toolErrorSettings: 'Le tue impostazioni non sono state modificate.',
  toolErrorAgent: 'Non è stato possibile creare l’agente.',
  toolErrorConnections: 'Non è stato possibile caricare le opzioni di collegamento.',
  toolErrorResult: 'Il risultato non è stato salvato.',
  toolErrorClarification: 'Non è stato possibile preparare il chiarimento.',
  toolErrorKnowledge: 'Non è stato possibile preparare l’aggiornamento suggerito delle conoscenze.',
  toolErrorQuestion: 'Non è stato possibile preparare la domanda.',
  toolErrorSkill: 'Non è stato possibile salvare la bozza della Skill.',
  toolErrorOpenSettings: 'Apri Impostazioni',
  toolErrorOpenAgents: 'Apri Agenti',
  toolErrorOpenConnections: 'Apri Connessioni',
  toolStepIncomplete: 'Questo passaggio non è stato completato.',
  toolEarlierAttemptsFailed:
    'one:tentativo precedente non è andato a buon fine|many:di tentativi precedenti non sono andati a buon fine|other:tentativi precedenti non sono andati a buon fine',
} satisfies AppCopy;
